<template>
  <div>
    <section id="whatWeDo">
<!--      <div class="shape shape-style-3 bg-secondary shape-skew"><span></span><span></span><span></span><span></span></div>-->
<!--      <div class="container pt-lg pb-300">-->
<!--        <div class="row text-center justify-content-center">-->
<!--          <div class="col-lg-10">-->
<!--            <h1 class=" fw-bold text-white-50">{{ $t("How it works") }}</h1>-->
<!--            <p class="lead text-white">-->
<!--            </p>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="row row-grid mt-5 justify-content-center">-->
<!--          <div class="col-md-4 pb-3">-->
<!--            <div class="card h-100">-->
<!--              <div class="card-body text-center">-->
<!--                <div class="icon mb-3" style="margin: 0 auto;">-->
<!--                  <i class="fas fa-user-plus fa-3x"></i> &lt;!&ndash; Font Awesome icon &ndash;&gt;-->
<!--                </div>-->
<!--                <h5 class="card-title">1: <router-link class="text-decoration-underline pe-2" to="/register">{{ $t("Register Online") }}</router-link>{{ $t("or with our App") }} </h5>-->
<!--                <p class="card-text">{{ $t("Create an account in seconds through our website or app, and tell us about your healthcare needs.") }}</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          &lt;!&ndash; Step 2 &ndash;&gt;-->
<!--          <div class="col-md-4 pb-3">-->
<!--            <div class="card h-100">-->
<!--              <div class="card-body text-center">-->
<!--                <div class="icon mb-3" style="margin: 0 auto;">-->
<!--                  <i class="fas fa-file-alt fa-3x"></i> &lt;!&ndash; Font Awesome icon &ndash;&gt;-->
<!--                </div>-->
<!--                <h5 class="card-title">2: {{ $t("Submit Your Request") }}</h5>-->
<!--                <p class="card-text">{{ $t("Choose the type of service you need, whether it’s nursing or a doctor’s visit.") }}</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          &lt;!&ndash; Step 3 &ndash;&gt;-->
<!--          <div class="col-md-4 pb-3">-->
<!--            <div class="card h-100">-->
<!--              <div class="card-body text-center">-->
<!--                <div class="icon mb-3" style="margin: 0 auto;">-->
<!--                  <i class="fas fa-user-md fa-3x"></i> &lt;!&ndash; Font Awesome icon &ndash;&gt;-->
<!--                </div>-->
<!--                <h5 class="card-title">3: {{ $t("Get Matched with a Professional") }}</h5>-->
<!--                <p class="card-text">{{ $t("The most appropriate healthcare professional will get in touch.") }}</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </section>
    <section id="contact-form" class="section section-lg pt-lg-0 section-contact-us mb-0">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <div class="card shadow bg-gradient-secondary">
              <div class="card-body p-lg-5">
<h4 class="mb-1">{{ $t("Contact Form") }}</h4>
<!--                <p class="mt-2">{{ $t("We are here to connect!") }} <br> {{ $t("Reach out, and we’ll get back to you as soon as possible.") }}</p>-->
                <div class="form-group mt-5 input-group input-group-alternative" :class="[{ 'has-danger': v$.model.name.$error }]">
                  <div class="input-group-prepend">
<span class="input-group-text"><i class="fa fa-user"></i></span>
                  </div>
                  <input v-model="model.name" aria-describedby="addon-right addon-left" :placeholder="$t('Full name')" class="form-control">
                  <div v-if="v$.model.name.$invalid" class="text-danger invalid-feedback" style="display: block;">
                    {{ $t(v$.model.name.$errors.map( err => { return err.$message })[0] ?? "") }}
                  </div>
                </div>

                  <div class="form-group input-group input-group-alternative">
<div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="fa fa-phone"></i>
                    </span>
                    </div>
                    <base-input
                        v-model="model.phoneNumber"
                        aria-describedby="addon-right addon-left"
                        type="number"
                        :form-classes="[{ 'has-danger': v$.model.phoneNumber.$error, 'form-control phone-input m-0 p-0': true }]"
                        style="display: flex;border-radius: 0;"
                        :placeholder="$t('Phone Number')"
                    >
                      <template #addonLeft>
                        <multiselect
                            v-model="model.phoneNumberCode"
                            :options="countryCodes"
                            placeholder=""
                            :show-labels="false"
                            :searchable="true"
                            :custom-label="customLabel"
                            required
                            :multiple="false"
                            class=""
                        >
                          <template #singleLabel="{ option }">
                            <img v-if="option.iso" alt="Country flag" width="25" :src="require('@/assets/images/flags/'+option.iso.toUpperCase()+'.png')" />
                            <span class="ps-1" style="line-height: 31px">{{ option.code }}</span>
                          </template>
                          <template #option="props">
                            <img v-if="props.option.iso" alt="Country flag" width="25" :src="require('@/assets/images/flags/'+props.option.iso.toUpperCase()+'.png')" />
                            {{ props.option.text }}
                          </template>
                        </multiselect>
                      </template>
                    </base-input>
                    <div v-if="v$.model.phoneNumber.$invalid" class="text-danger invalid-feedback" style="display: block;">
                      {{ $t(v$.model.phoneNumber.$errors.map( err => { return err.$message })[0] ?? "") }}
                    </div>
                  </div>

                <div class="form-group input-group input-group-alternative" :class="[{ 'has-danger': v$.model.email.$error }]">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="fa fa-envelope"></i>
                    </span>
                  </div>
                  <input v-model="model.email" aria-describedby="addon-right addon-left" :placeholder="$t('Email address')" class="form-control">
                  <div v-if="v$.model.email.$invalid" class="text-danger invalid-feedback" style="display: block;">
                    {{ $t(v$.model.email.$errors.map( err => { return err.$message })[0] ?? "") }}
                  </div>
                </div>

<!--                <div class="form-group input-group input-group-alternative" :class="[{ 'has-danger': v$.model.type.$error }]">-->
<!--                  <div class="input-group-prepend custom-transition-form">-->
<!--                    <span class="input-group-text">-->
<!--                      <i class="fa fa-user-doctor"></i>-->
<!--                    </span>-->
<!--                  </div>-->
<!--                  <div  class="form-control p-0">-->
<!--                  <multiselect v-model="model.type" class="custom-transition-form" :placeholder="$t('What are you looking for?')" :options="[ $t('Looking for home-care services'), $t('I am a certified nurse, doctor and I want to get more shifts')]"></multiselect>-->
<!--                  </div>-->
<!--                  <div v-if="v$.model.type.$invalid" class="text-danger invalid-feedback" style="display: block;">-->
<!--                    {{ v$.model.type.$errors.map( err => { return err.$message })[0] }}-->
<!--                  </div>-->
<!--                </div>-->
                <div class="form-group mb-4" :class="[{ 'has-danger': v$.model.email.$error }]">
<textarea v-model="model.description" name="description" rows="4" cols="80" :placeholder="$t('Type a message...')"
                            class="form-control form-control-alternative"
>

                  </textarea>
                  <div v-if="v$.model.description.$invalid" class="text-danger invalid-feedback" style="display: block;">
                    {{ $t(v$.model.description.$errors.map( err => { return err.$message })[0] ?? "") }}
                  </div>
                  </div>
                <base-button type="primary" :disabled="loadingProcess === 'processing'" class="mt-4 mb-2" @click="submitForm()">
                  <template v-if="loadingProcess === 'processing'">
                    <span class="fas fa-cog fa-spin" aria-hidden="true"></span>
                  </template>
                  <template v-else>
                    {{ $t("Send message") }}
                  </template>
                </base-button>
                <base-alert v-if="loadingProcess === 'failed'" type="" dismissible>
                  <strong></strong> {{ $t(errorMessage) }}
                </base-alert>
              </div>
</div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core"
import {email, helpers, required} from "@vuelidate/validators"
import FirebaseFunctionsHelper from "@/helpers/firebaseFunctionsHelper"
import {isWindows} from "@/helpers/common"
import {getCountries, getCountryCallingCode, isValidNumber} from "libphonenumber-js"
import BaseInput from "@/components/BaseInput"
import BaseButton from "@/components/BaseButton.vue"
import BaseAlert from "@/components/BaseAlert.vue"
const isValidPhone = (param) => helpers.withParams(
    { type: "isValidPhone", value: param }, (value) => {

      if (value == null || value === ""){
        return true
      }
      console.log("param+value", param+value)
      return isValidNumber(param+value)
    })
export default {
  name: "ContactUs",
  components: {BaseAlert, BaseButton, BaseInput},
  setup: () => ({ v$: useVuelidate() }),
  data: () => {
    return {
      countryCodes: [],
      isWindows,
      loadingProcess: "",
      errorMessage: "",
      model: {
        name: null,
        email: null,
        type: null,
        description: "",
        phoneNumber: "",
        phoneNumberCode: {code: "+357", text: "", iso: "CY"},
      }
    }
  },
  validations () {
    return {
      model: {
        name: {
          required
        },
        description: {
          required
        },
        email: {
          required, email
        },
        phoneNumber: {
          required,
          validated: helpers.withMessage(this.$t("Must be valid phone number."), isValidPhone(this.model.phoneNumberCode?.code))
        },
      }
    }
  },
  mounted() {
    let countries = ["CY", "GB", "GR"]

    countries.forEach(country => {
      let code = getCountryCallingCode(country)
      this.countryCodes.push({code: "+" + code, text: this.$t(country) + " +" + code, iso: country})
    })
  },
  methods: {
    customLabel(option) {
      return `${option.text}`
    },
    submitForm() {
      this.v$.$touch()

      if (this.v$.model.$invalid) {
        console.log(this.v$.$errors)
        return
      }
      this.loadingProcess = "processing"

      FirebaseFunctionsHelper.callFunction("company-contactForm", {
        name: this.model.name,
        subject: "Contact form",
        message: this.model.description === "" ? "No message" : this.model.description,
        email: this.model.email,
        phoneNumber: this.model.phoneNumberCode.code + this.model.phoneNumber
      }).then((data) => {
        // console.log("dataa", data)
        if (data === null) {
          this.loadingProcess = "done"
          this.model.name = null
          this.model.email = null
          this.model.type = null
          this.model.phoneNumber = null
          this.model.description = ""
          this.v$.$reset()
          this.$swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            icon: "success",
            title: this.$t("Thank you for contacting us!"),
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer)
              toast.addEventListener("mouseleave", this.$swal.resumeTimer)
            }
          })
        } else {
          this.loadingProcess = "failed"
          this.errorMessage = this.$t(data.message)
        }
      }).catch((error) => {
            this.loadingProcess = "failed"
            this.errorMessage = error.message
            console.error(error)
          })
    }
  }
}
</script>

<style>
@media (min-width: 992px) {
  .pb-300 {
    padding-bottom: 300px !important;
  }
}

  @media (min-width: 992px) {
    .mt--300 {
      margin-top: -300px !important;
    }
  }

.custom-transition-form {
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
  border: 0;
  transition: box-shadow 0.15s ease;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.custom-transition-form .multiselect__tags {
  border: none !important;
}

.col-lg-4.box {
  transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  -webkit-transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.col-lg-4.box:hover {
  box-shadow: rgba(17, 17, 26, 0.1) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 48px;
  /*transition: box-shadow,transform, background 0.3s ease-in-out;*/
  background: #8b154e;
  -webkit-transform: scale(1.10, 1.10);
  transform: scale(1.10, 1.10);
}

.col-lg-4.box:hover p, .col-lg-4.box:hover h5 {
  color: white !important;
}

.box .icon i {
  font-size: 2.3rem;
}
.form-group.input-group.form-control.phone-input.m-0.p-0 .input-group-prepend {
  border-radius: 0;
}
</style>


